<div [formGroup]="form">
  <mat-checkbox *ngIf="!readonly" [formControlName]="attribute.identifier" [required]="true">{{attribute.name}}
  </mat-checkbox>
</div>
